var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{staticClass:"error-img",attrs:{"src":require("../assets/404.png"),"alt":""}}),_c('a',{staticClass:"btn",attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v("返回上一页")])])
}
var staticRenderFns = []

export { render, staticRenderFns }